import { combineReducers } from "redux";
import { createItemReducer, createItemReducerParams } from "@mnjsplatform/data/lib/reducers/dataItemReducer";

export function confidentialInformationReducer() {
    return combineReducers({
        ConfidentialInformation_ListSubForPO: createItemReducer("ConfidentialInformation", "PersonalCard.ListSubForNewPO", false),
        ConfidentialInformation_ListSubForPOParams: createItemReducerParams("ConfidentialInformation", "PersonalCard.ListSubForNewPO")
    });
}